import React, { useState } from 'react';
import { themes, getCurrentTheme, setTheme, ThemeName } from '../../theme';

const ThemeSettings: React.FC = () => {
  const [currentTheme, setCurrentTheme] = useState<ThemeName>(getCurrentTheme());

  return (
    <div className="card">
      <h2 className="title-lg mb-md">Theme</h2>
      <p className="subtitle mb-lg">
        Choose your preferred visual theme. Your selection is saved automatically.
      </p>

      <div
        className="grid gap-md"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}
      >
        {themes.map((t) => (
          <div
            key={t.name}
            onClick={() => {
              setTheme(t.name);
              setCurrentTheme(t.name);
            }}
            className="card"
            style={{
              cursor: 'pointer',
              border:
                currentTheme === t.name
                  ? '2px solid var(--primary)'
                  : '1px solid var(--grid-line)',
              boxShadow: currentTheme === t.name ? 'var(--border-glow)' : 'none',
              transition: 'all 0.2s',
            }}
          >
            <div className="flex justify-between items-center mb-sm">
              <h3 className="title-md">{t.label}</h3>
              {currentTheme === t.name && <span className="badge badge-cyan">Active</span>}
            </div>
            <p className="subtitle">{t.description}</p>

            {/* Color preview */}
            <div className="flex gap-sm mt-md">
              {t.name === 'neon-grid' && (
                <>
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#0a0a0f',
                      border: '1px solid #1a1a2e',
                    }}
                    title="Background"
                  />
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#00d4ff',
                    }}
                    title="Primary"
                  />
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#ff00d4',
                    }}
                    title="Secondary"
                  />
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#00ff9d',
                    }}
                    title="Success"
                  />
                </>
              )}
              {t.name === 'midnight' && (
                <>
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#0f0a1a',
                      border: '1px solid #2a1f4e',
                    }}
                    title="Background"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#a855f7' }}
                    title="Primary"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#f472b6' }}
                    title="Secondary"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#4ade80' }}
                    title="Success"
                  />
                </>
              )}
              {t.name === 'light' && (
                <>
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 4,
                      background: '#f8fafc',
                      border: '1px solid #e2e8f0',
                    }}
                    title="Background"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#0284c7' }}
                    title="Primary"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#7c3aed' }}
                    title="Secondary"
                  />
                  <div
                    style={{ width: 24, height: 24, borderRadius: 4, background: '#16a34a' }}
                    title="Success"
                  />
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemeSettings;
